import BulkTableModal from '../form/bulk-table/BulkTableModal';

type Props = {
  formId: string;
  onClose: (path: string) => void;
};

export default function ScsManagerDetailsReminder({ formId, onClose }: Props) {
  const detailsPath = `/scs/cover-sheet/cover-sheet/person-details?formId=${encodeURIComponent(formId)}`;
  const dismiss = () => onClose('/scs?my_forms=1&admin=0');
  return (
    <BulkTableModal title="Form sent for approval" onClose={dismiss}>
      <p className="govuk-body">
        If your job title, grade, profession, business unit or temporary promotion details have also
        changed. Please update the{' '}
        <a
          className="govuk-link"
          href={detailsPath}
          onClick={(event) => {
            event.preventDefault();
            onClose(detailsPath);
          }}
        >
          Your Details
        </a>{' '}
        section of your form.
      </p>
      <button type="button" className="govuk-button" onClick={dismiss}>
        OK
      </button>
    </BulkTableModal>
  );
}
